import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import * as React from 'react';
import cn from 'classnames';
export var Loader = function Loader(props) {
  var _React$useState = React.useState(false),
    _React$useState2 = _slicedToArray(_React$useState, 2),
    visible = _React$useState2[0],
    setVisible = _React$useState2[1];
  React.useEffect(function () {
    var timer;
    if (props.isLoading) {
      timer = window.setTimeout(function () {
        setVisible(true);
      }, props.delay);
    } else {
      setVisible(false);
    }
    return function () {
      if (timer) {
        window.clearTimeout(timer);
      }
    };
  }, [props.isLoading]);
  var renderDots = function renderDots() {
    var dots = [];
    var delay = props.duration / props.count;
    for (var i = 0; i < props.count; i++) {
      dots.push(React.createElement("div", {
        key: i,
        style: {
          animationDuration: "".concat(props.duration, "ms"),
          animationDelay: "".concat(delay * i, "ms")
        }
      }));
    }
    return dots;
  };
  var classNames = cn('loader', {
    '-inverse': props.isInverse,
    '-visible': visible,
    '-active': props.isLoading
  });
  return React.createElement("div", {
    className: classNames
  }, renderDots());
};
Loader.displayName = 'Loader';
Loader.defaultProps = {
  count: 4,
  isLoading: true,
  isInverse: false,
  duration: 1200,
  delay: 400
};